<template>
    <div class="home">
        <div class="top" :class="{ 'top-active': topShow }">
            <img class="logo" src="@/assets/image/logo.png" alt="" @click="onClickLogo" />
            <div class="tabs">
                <div
                    class="tabs-item"
                    :class="{ 'tabs-item-active': tabIndex === index }"
                    v-for="(items, index) in tabs"
                    :key="index"
                    @click="onClickTab(index)"
                >
                    <!-- <a :href="`#tab${index}`"> -->
                    <div class="name" :class="{ 'name-active': tabIndex === index }">
                        {{ items.name }}
                    </div>
                    <div class="desc" :class="{ 'name-active': tabIndex === index }">
                        {{ items.desc }}
                    </div>
                    <!-- </a> -->
                </div>
            </div>
        </div>
        <div class="main">
            <!-- 轮播图 -->
            <Banner :banners="banners" />
            <!-- 关于我们 -->
            <div id="tab0" class="content easein about" :class="{ 'easein-active': opacitys[0] }">
                <div class="title">
                    about Us
                    <div class="title-sub">关于我们</div>
                </div>
                <div class="about-desc easein" :class="{ 'easein-active': opacitys[0] }" v-html="about.content"></div>
                <el-image :src="about.image" />
            </div>
            <!-- 业务范围 -->
            <Business :signProduct="signProduct" :desc="desc" :opacitys="opacitys[1]" />
            <!-- 动态漫画 -->
            <Comics :desc="desc" :opacitys="opacitys[2]" />
            <!-- 广播剧 -->
            <Broadcast :dramas="dramas" :desc="desc" :opacitys="opacitys[3]" />
            <!-- 周边 -->
            <Surrounding :surrounding="surrounding" :desc="desc" :opacitys="opacitys[4]" />
            <!-- 底部 -->
            <Footer :baseInfo="baseInfo" :links="links" />
            <!-- <svg-icon iconClass="top" class="top-top" @click="onClickLogo" v-if="showTop"></svg-icon> -->
            <img src="@/assets/image/top.png" class="top-top" @click="onClickLogo" v-if="showTop" />
            <!-- <svg-icon iconClass="top-white" class="top-top" @click="onClickLogo" v-if="showTop"></svg-icon> -->
        </div>
    </div>
</template>

<script>
import {
    findAbout,
    findSignProductList,
    findDramaList,
    findBaseInfo,
    findDesc,
    findSurrounding,
    findBanner,
    findLinkList,
} from '@/api/home'
import Banner from './components/banner.vue'
import Business from './components/business.vue'
import Broadcast from './components/broadcast.vue'
import Surrounding from './components/surrounding.vue'
import Footer from './components/footer.vue'
import Comics from './components/comics.vue'
// import _ from 'lodash'

export default {
    name: 'Home',
    components: {
        Banner,
        Business,
        Broadcast,
        Surrounding,
        Footer,
        Comics,
    },
    data() {
        return {
            tabIndex: -1,
            tabs: [
                {
                    name: '关于我们',
                    desc: 'About Us',
                },
                {
                    name: '漫画作品',
                    desc: 'Comic Works',
                },
                {
                    name: '动态漫画',
                    desc: 'Motion Comic',
                },
                {
                    name: '广播剧',
                    desc: 'Radio Drama',
                },
                {
                    name: '周边',
                    desc: 'Goods',
                },
                {
                    name: '联系我们',
                    desc: 'Contact Us',
                },
            ],
            about: {
                content: '',
                image: '',
            },
            isScroll: false,
            signPage: {
                pageNo: 1,
                pageSize: 10,
            },
            signProduct: [],
            dramas: [],
            surrounding: [],
            banners: [],
            links: [],
            desc: {
                comic: {
                    configName: '',
                    configContent: '',
                },
                motion_comic: {
                    configName: '',
                    configContent: '',
                },
                drama: {
                    configName: '',
                    configContent: '',
                },
                products: {
                    configName: '',
                    configContent: '',
                },
            },
            baseInfo: {
                email: {},
                phone: {},
                address: {},
                archival_information: {},
                copyright_information: {},
                wechat: {},
                web_name: {},
                url: {},
            },
            opacitys: {
                0: false,
                1: false,
                2: false,
                3: false,
                4: false,
                5: false,
            },
            scrollTo: 0,
            comicsPosition: 0,
            historyScrollTop: 0,
            topShow: false,
            comicsShow: false,
            showTop: false,
            init: true,
        }
    },
    computed: {
        swiper() {
            return this.$refs.mySwiper.$swiper
        },
        comicsSwiper() {
            return this.$refs.comicsSwiper.$swiper
        },
        comicsSwiper2() {
            return this.$refs.comicsSwiper2.$swiper
        },
    },
    created() {
        this.findBanner()
        this.findAbout()
        this.findDesc()
        this.findDramaList()
        this.findSignProductList()
        this.findSurrounding()
        this.findBaseInfo()
        this.findLinkList()
    },
    mounted() {
        window.addEventListener('scroll', this.onScroll)
        this.onScroll()
    },
    destroyed() {
        window.removeEventListener('scroll', this.onScroll)
    },
    methods: {
        onClickLogo() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            })
        },
        onClickTab(index) {
            this.tabIndex = index

            for (let i = 0; i <= index; i++) {
                this.opacitys[i] = true
            }

            this.isScroll = true

            const navContents = document.querySelectorAll('.content')

            // 所有锚点元素的 offsetTop
            const offsetTopArr = []

            const clientHeights = []

            navContents.forEach((item) => {
                offsetTopArr.push(item.offsetTop)
                clientHeights.push(item.clientHeight)
            })

            const [offsetTop] = offsetTopArr.filter((items, i) => i == index)

            const [height] = clientHeights.filter((items, i) => i == index)

            this.scrollTo = offsetTop + height - 88

            window.scrollTo({
                top: this.scrollTo,
                behavior: 'smooth',
            })
        },
        onScroll() {
            // if (this.init) {
            //     this.init = false
            //     this.onClickLogo()
            //     return
            // }
            const navContents = document.querySelectorAll('.content')

            // 所有锚点元素的 offsetTop
            const offsetTopArr = []

            const offsets = []

            navContents.forEach((item, index) => {
                offsetTopArr.push(item.offsetTop)
                if (index > 0) {
                    offsets.push(item.getBoundingClientRect())
                }
            })

            // 获取当前文档流的 scrollTop
            let scrollTop = document.documentElement.scrollTop || document.body.scrollTop

            if (this.isScroll) {
                if (scrollTop == this.scrollTo) {
                    const timer = setTimeout(() => {
                        this.isScroll = false
                        clearTimeout(timer)
                    }, 500)
                }
                return
            }

            scrollTop = scrollTop - 88

            // 定义当前点亮的导航下标
            let navIndex = -1

            for (let n = 0; n < offsetTopArr.length; n++) {
                // 如果 scrollTop 大于等于第 n 个元素的 offsetTop 则说明 n-1 的内容已经完全不可见
                // 那么此时导航索引就应该是 n 了
                if (scrollTop >= offsetTopArr[n]) {
                    navIndex = n
                }
            }

            if (scrollTop <= 0) {
                this.topShow = false
            } else if (scrollTop > 20) {
                this.topShow = true
            }

            const height = (window.innerHeight || document.documentElement.clientHeight) / 2

            if (scrollTop > height) {
                this.showTop = true
            } else {
                this.showTop = false
            }

            this.historyScrollTop = scrollTop

            // 把下标赋值给 vue 的 data
            this.tabIndex = navIndex

            this.$set(this.opacitys, navIndex, true)

            offsets.forEach((items, index) => {
                const show =
                    items.top >= (window.innerHeight || document.documentElement.clientHeight) || items.bottom <= 0
                this.$set(this.opacitys, index, !show)
            })
        },
        async findBanner() {
            const res = await findBanner()

            this.banners = res
        },
        async findAbout() {
            const res = await findAbout()

            const [text, img] = res

            this.about = {
                content: text.configContent,
                image: img.configContent,
            }
        },
        async findSignProductList() {
            const params = {
                ...this.signPage,
            }

            const res = await findSignProductList(params)

            const { rows } = res

            // this.signProduct = _.chunk(rows || [], 3)
            this.signProduct = rows
        },
        async findDramaList() {
            const params = {
                ...this.signPage,
            }

            const res = await findDramaList(params)

            const { rows } = res

            // this.dramas = _.chunk(rows || [], 3)
            this.dramas = rows
        },

        async findBaseInfo() {
            const res = await findBaseInfo()

            res.forEach((items) => {
                this.baseInfo[items.configKey] = items
            })
        },
        async findDesc() {
            const res = await findDesc()

            res.forEach((items) => {
                this.desc[items.configKey] = {
                    configName: items.configName,
                    configContent: items.configContent,
                }
            })
        },
        async findSurrounding() {
            const res = await findSurrounding()

            this.surrounding = res
        },
        async findLinkList() {
            const res = await findLinkList()

            this.links = res
        },
    },
}
</script>

<style lang="scss">
.easein {
    opacity: 0;
    transform: translateY(40px);
    transition: transform 1s ease-in-out 0.15s, opacity 1s ease-in-out 0.15s;
    backface-visibility: hidden;
}

.easein-active {
    transform: translateY(0);
    transition: transform 1s ease-in-out 0.15s, opacity 1s ease-in-out 0.15s;
    backface-visibility: hidden;
    opacity: 1;
}

a {
    text-decoration: none;
    color: inherit;
}

.home {
    width: 100%;
    min-height: 100vh;
    height: calc(100vh - 88px);
    background: #fff;
    .top {
        width: 100%;
        height: 88px;
        background: #fff;
        display: flex;
        align-content: center;
        position: fixed;
        z-index: 12001;
        transform: translateY(0);
        transition: all ease-in-out 0.5s;
        .logo {
            width: 186px;
            height: 56px;
            margin-left: 160px;
            padding: 16px 0;
            cursor: pointer;
        }
        .tabs {
            margin-left: 334px;
            display: flex;
            .tabs-item {
                width: 180px;
                height: 88px;
                // line-height: 88px;
                text-align: center;
                cursor: pointer;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-content: center;
            }
            .tabs-item-active {
                background: #f1592a;
            }
            .name {
                color: #333333;
                font-size: 18px;
                font-weight: 500;
            }
            .desc {
                color: #999999;
                font-size: 10px;
                font-weight: 500;
            }
            .name-active {
                color: #fff;
            }
        }
    }
    .top-active {
        transform: translateY(-90px);
        transition: all ease-in-out 0.5s;
    }
    .main {
        padding-top: 88px;
        position: relative;
        .swiper-button-prev,
        .swiper-button-next {
            width: 100px;
            height: 100px;
            border-radius: 50%;
            background: #999;
            opacity: 0.5;
            color: #fff;
            z-index: 11011;
            pointer-events: auto;
            cursor: pointer;
            outline: none;
        }
        .swiper-pagination,
        .swiper-pagination1 {
            bottom: 20px;
            left: 50%;
            transform: translateX(-50%);
            font-size: 16px;
            .swiper-pagination-bullet {
                background: #fff;
                width: 10px;
                height: 10px;
                border-radius: 50%;
                opacity: 1;
                margin-right: 30px;
            }
            .swiper-pagination-bullet-active {
                background: #dd551a;
                width: 50px;
                height: 10px;
                border-radius: 6px;
            }
        }
        .swiper-pagination1 {
            bottom: 80px;
            position: absolute;
            z-index: 11011;
        }

        .title {
            color: rgba($color: #333333, $alpha: 0.08);
            font-size: 60px;
            font-weight: bold;
            position: relative;
            .title-sub {
                color: #333333;
                font-size: 30px;
                font-weight: bold;
                position: absolute;
                left: 50%;
                transform: translateX(-50%);
                bottom: 0;
            }
        }
        .split-title {
            color: #333333;
            font-size: 20px;
            font-weight: 800;
            margin-top: 80px;
            display: flex;
            align-items: center;
            justify-content: center;
            .line {
                width: 57px;
                height: 2px;
                background: #333333;
                display: inline-block;
                margin: 0 20px;
            }
        }

        .split-desc {
            color: #666666;
            font-size: 14px;
            font-weight: 500;
            margin-top: 12px;
        }

        .about {
            text-align: center;
            .about-desc {
                color: #666;
                font-size: 16px;
                font-weight: 500;
                text-align: center;
                width: 880px;
                margin: 0 auto;
                margin-top: 10px;
            }
            .el-image {
                width: 1600px;
                height: 800px;
                margin-top: 20px;
            }
            .el-image:hover {
                transform: scale(1.02);
                animation: fade 600ms 1;
                -webkit-animation: fade 600ms 1;
            }
        }
        .top-top {
            position: fixed;
            bottom: 20%;
            right: 40px;
            width: 80px;
            height: 80px;
            opacity: 0.9;
            cursor: pointer;
            z-index: 11011;
        }
    }
}
</style>
